export class ChartAggModel {
    constructor(
        public readonly name: string,
        public readonly agg: string,
        public value: string,
    ) {
        this.color = this.getColor(agg);
    }

    public color: string;
    public compareValue: string;

    private getColor = (agg: string): string =>{
        let color: string = '';
        switch (agg){
            case 'AVG': color = '#000066'; break;
            case 'MIN': color = '#336699'; break;
            case 'MAX': color = '#00ccff'; break;
            case 'SUM': color = '#006633'; break;
        }
        return color;
    }

}

export class ChartAggDatesModel {
    constructor(
        public period: string,
        public from: Date,
        public to: Date
    ){}
}

export class ChartAggDataBuffer {
    constructor(
        public avg: number,
        public min: number,
        public max: number,
        public cnt: number

    ){}
}

export class ChartAggDataSales {
    constructor(
        public sumSales: number,
        public sumDiscountSales: number,
        public sumOther: number,
        public avg: number,
        public max: number,
        public min: number,
        public cnt: number,
        public withSales: number,
        public withoutSales: number
    ){}
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/amchart/chart-aggregation.ts